// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p[data-v-a24750a6]{margin-top:12px;margin-bottom:12px}", "",{"version":3,"sources":["webpack://./apps/files_sharing/src/components/PersonalSettings.vue"],"names":[],"mappings":"AACA,mBACC,eAAA,CACA,kBAAA","sourcesContent":["\np {\n\tmargin-top: 12px;\n\tmargin-bottom: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
